import { ApiResponseType } from 'src/shared';
import { HttpHandler } from './HttpHandler';
import { environment } from 'src/enviroments';

export const getVideoCallToken = async (consultationId: string): Promise<ApiResponseType<string>> => {
  const { data: flowData } = await HttpHandler({
    method: 'GET',
    url: `${environment.VIDEO_CALL_URL}/token/${consultationId}`,
  });

  return flowData;
};

export const isBetaTester = async (specialistId: string): Promise<ApiResponseType<string>> => {
  const { data: flowData } = await HttpHandler({
    method: 'GET',
    url: `${environment.VIDEO_CALL_URL}/new-call-available/${specialistId}`,
  });

  return flowData;
};

export const getJitsiVideoCallToken = async (consultationId: string): Promise<ApiResponseType<string>> => {
  const { data: flowData } = await HttpHandler({
    method: 'GET',
    url: `${environment.VIDEO_CALL_URL}/client/token/jitsi/${consultationId}`,
  });

  return flowData;
};
